// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"267":"885023dbeef141f0f552","524":"1114d6faf1c52e15aa38","833":"988d2c69bc00c3cd14a4","926":"80f1bae5b34c0ed5ca2a"}[chunkId] + ".chunk.js";
};